import flatMap from 'lodash/flatMap';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import omit from 'lodash/omit';
import toPairs from 'lodash/toPairs';

function isLinkTarget(path) {
  return ['.campaignLines', '.quoteLines'].includes(path);
}

export function getErrorTargetId(type, key) {
  return `${type}-${key}`;
}

// Linearize error responses into a list.
//
// Errors are generally represented by objects,
// mapping field names to arrays of messages:
//
//   { "name": ["cannot be empty"] }
//
// Errors on nested resources, e.g. campaign lines or quote lines are
// addressed by either resource "id" - if present - or index:
//
//   {
//     "campaignLines": [
//       { "id": "123", "mediaSet": ["invalid"] }
//     ]
//   }
//
//   {
//     "quoteLines": [
//       {},
//       { "startDate": ["cannot be in the past"] }
//     ]
//   }
//
export function linearize(target, path = '', linkTarget = null) {
  if (isArray(target)) {
    // there were multiple validation errors for the field

    if (target.every(isString)) {
      // target is a list of plain error messages
      return [{ path: path.slice(1), message: target.join(', '), linkTarget }];
    }

    // target contains error objects for nested resources,
    // addressed by "id" or "index"
    return flatMap(target, (item, idx) =>
      linearize(
        item,
        `${path}[${item.id || idx + 1}]`,
        isLinkTarget(path)
          ? { type: path.slice(1), id: item.id || idx }
          : linkTarget,
      ),
    );
  }

  if (isObject(target)) {
    // target is an object mapping field names to errors,
    // the "id" field is expected never to contain errors
    return flatMap(toPairs(omit(target, 'id')), ([key, value]) =>
      linearize(value, `${path}.${key}`, linkTarget),
    );
  }

  return [{ path: path.slice(1), message: target, linkTarget }];
}
